import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useMediaQuery } from 'react-responsive';
import styled from 'styled-components';
import { isSupported } from 'twilio-video';

import { breakpoints } from 'helpers/styles/constants';
import IconExclamationCircle from 'components/Icons/IconExclamationCircle';
import useModalState from 'components/ModalHandler/useModalState';

import BrowserWarningModal from './BrowserWarningModal';

const InlineButton = styled.span`
  margin-left: 0.25em;
  font-weight: bold;
  cursor: pointer;
  color: #036;
`;

const OutWrapper = styled.div`
  height: 80px;
`;

const Wrapper = styled.div`
  position: fixed;
  z-index: 999999;
  width: 100%;
  padding: 1.25em 0;
  background-color: ${({ theme }) => theme.colors.orangeWarning};
`;

const Text = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  line-height: 1.25;
  color: ${({ theme }) => theme.colors.white};
  gap: 0.25em;
`;

export default function BrowserWarningBanner() {
  const [isModalOpen, openModal, closeModal] = useModalState();
  const isMobile = useMediaQuery({ query: breakpoints.xsDown });
  const textId = isMobile ? 'mobile' : 'desktop';

  if (isSupported) return null;
  return (
    <OutWrapper>
      <Wrapper id="browser-warning-banner">
        <Text>
          <IconExclamationCircle height={20} width={20} fill="white" />
          <FormattedMessage id={`dashboard.shared.browserWarning.${textId}FirstLine`} />
        </Text>
        <Text>
          <FormattedMessage id={`dashboard.shared.browserWarning.${textId}SecondLine`} />
          <InlineButton onClick={openModal}>Learn More</InlineButton>
        </Text>
      </Wrapper>

      <BrowserWarningModal isOpen={isModalOpen} closeModal={closeModal} />
    </OutWrapper>
  );
}
